import CoreApi from '../../api/CoreApi';
import { createQueryFn, QueryNameSpace } from '../../lib/query';

export const publicGetGamificationBenefits = createQueryFn(
  QueryNameSpace.publicGetGamificationBenefits,
  async () => {
    const { benefits } = await CoreApi.publicGetGamificationBenefits();

    return benefits;
  },
);
